module.exports = __webpack_public_path__ + "static/media/coupleCake1.3e93f160.png";